import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges, OnChanges} from "@angular/core";
import {ElementService} from "../services/element.service";

@Component({
    selector: 'app-pagination',
    templateUrl: './pagination.component.html',
    standalone: false
})

export class PaginationComponent implements OnInit, OnChanges {

  /**
   * Holds the count of all items
   */
  @Input() itemCount: number;

  /**
   * Holds the count of items we want to show on one page
   */
  @Input() itemsPerPage: number;

  /**
   * HTML target element with specific id to jump to
   */
  @Input() clickTarget: string = null;

  /**
   * Holds the id as reference for aria-controls in pagination buttons
   */
  @Input() ariaControlsTarget?: string | null;

  /**
   * Event emitter is called when clicked on inactive page in navigation
   */
  @Output() onPageChange: EventEmitter<number> = new EventEmitter<number>();

  /**
   * Holds the total number of pages
   */
  totalPages: number;

  /**
   * Holds the total number of pages converted to an array
   */
  pages: any[] = [];

  /**
   * Holds the current page number
   */
  currentPage: number = 1;

  /**
   * Toggle if result is initialized
   */
  isResultInitialized: boolean = false;

  constructor(protected elementService: ElementService) {
  }

  /**
   * @inheritDoc
   */
  ngOnInit() {
    //set total pages count
    this.setTotalPages();
    // set to true after initializing result page
    this.isResultInitialized = true;
  }

  /**
   * @inheritDoc
   * @param changes
   */
  ngOnChanges(changes: SimpleChanges) {
    //update total pages count and reset start index
    if(changes.hasOwnProperty('itemCount') && changes.itemCount.currentValue !== changes.itemCount.previousValue) {
      this.setTotalPages();
      this.changePage(1);
      this.convertToArray();
    }

    // update items per page count and reset start index
    if(changes.hasOwnProperty('itemsPerPage')  && changes.itemsPerPage.currentValue !== changes.itemsPerPage.previousValue) {
      this.setTotalPages();
      this.changePage(1);
      this.convertToArray();
    }
  }

  /**
   * set the total pages
   */
  setTotalPages(): void {
    if(this.itemCount) {
      this.totalPages = Math.ceil(this.itemCount / this.itemsPerPage);
    }
  }

  /**
   * convert total pages count into array
   */
  convertToArray() {
    //reset pages
    this.pages = [];
    //convert total pages count into array
    for(let i = 1; i <= this.totalPages; i++) {
      this.pages.push(i);
    }
  }

  /**
   * Event emitter to change the page
   * @param page
   */
  changePage(page: number): void {
    //if page does not exist do nothing
    if(page < 1 || page > this.totalPages) {
      return;
    }
    this.currentPage = page;
    const startIndex = (this.currentPage -1) * this.itemsPerPage;
    this.onPageChange.emit(startIndex);

    // jump to target element after click on pagination
    if(this.isResultInitialized && this.clickTarget) {
      this.elementService.scrollToElement(document.querySelector('#' + this.clickTarget));
    }
  }

}
